export const BASE = ''
export const SET_BOOTSTRAP_DATA = `${BASE}/SET_BOOTSTRAP_DATA`

export function setBootstrapData(bootstrapData) {
  return {
    type: SET_BOOTSTRAP_DATA,
    payload: bootstrapData,
  }
}
